export default "__VITE_ASSET__BHJEkCRt__"